import { render, staticRenderFns } from "./backgrounds.vue?vue&type=template&id=4f0e3834"
import script from "./backgrounds.vue?vue&type=script&lang=js"
export * from "./backgrounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports